/* projects/common-module/src/lib/aur-datepicker/datepicker/aur-datepicker.component.scss */
button {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 36px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}
button:hover:not(.disabled):not(:disabled) {
  background-image: linear-gradient(color-mix(in srgb, currentColor 10%, transparent), color-mix(in srgb, currentColor 10%, transparent));
}
button:active:not(.disabled):not(:disabled) {
  background-image: linear-gradient(color-mix(in srgb, currentColor 16%, transparent), color-mix(in srgb, currentColor 16%, transparent));
}
button.in-range {
  background-color: var(--aur-calendar-range-background, #eef3fa);
  border-radius: 4px;
}
button.selected {
  background-color: var(--aur-calendar-primary, #2b5f9e);
  color: var(--aur-calendar-on-primary, #ffffff);
  font-weight: 600;
  border-radius: 8px;
}
button.disabled {
  color: var(--aur-calendar-disabled-text, #a7aebd);
  background-color: var(--aur-calendar-disabled-background, transparent);
  cursor: default;
}
button:focus-visible {
  outline: 2px solid var(--aur-calendar-focus, #235081);
  outline-offset: 2px;
}
:host {
  display: block;
}
.months {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 24px;
}
.months .month {
  flex: 1 1 264px;
  width: 264px;
  min-width: 264px;
}
.calendar-header,
.calendar-body {
  color: var(--aur-calendar-text, #1d222c);
  background-color: var(--aur-calendar-background, #ffffff);
  font-family: var(--aur-calendar-font-family, "Inter Tight", "Helvetica Neue", Helvetica, system-ui, sans-serif);
  font-size: 14px;
  line-height: 1.5;
}
.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  min-height: 28px;
  margin-bottom: 8px;
  color: var(--aur-calendar-text, #1d222c);
  font-weight: 500;
}
.calendar-header button {
  width: 28px;
  min-height: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 8px;
}
.navigation-slot {
  width: 28px;
  flex: 0 0 28px;
  color: var(--aur-calendar-navigation-text, #5e6676);
}
.calendar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  flex-wrap: wrap;
}
.calendar-header .title-button {
  width: auto;
  min-height: 25px;
  height: auto;
  padding: 2px 6px;
  border-radius: 6px;
  font-weight: inherit;
}
.calendar-body.stable-size {
  position: relative;
  height: 250px;
}
.calendar-body.stable-size > aur-calendar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.period-grid {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
  padding: 8px 0;
  box-sizing: border-box;
}
.period-row {
  display: flex;
  flex: 1;
  gap: 8px;
  min-height: 0;
}
.period-cell {
  flex: 1;
  min-width: 0;
}
.period-cell button {
  height: 100%;
  aspect-ratio: auto;
  font-weight: 400;
  overflow-wrap: anywhere;
}
.period-cell button.selected {
  font-weight: 500;
}
.calendar-header button:disabled {
  opacity: 0.4;
  cursor: default;
  background: transparent;
}
:host(.mobile-layout).compact-on-small-screens .calendar-body.stable-size:has(> aur-calendar) {
  height: auto;
}
:host(.mobile-layout).compact-on-small-screens .calendar-body.stable-size:has(> aur-calendar) > aur-calendar {
  position: static;
}
.calendar-content {
  position: relative;
}
.navigation-open {
  visibility: hidden;
}
.navigation-panel {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
}
.navigation-panel > .period-grid {
  flex: 1;
  min-height: 0;
  height: auto;
}
.header-spacer {
  height: 28px;
}
:host(.mobile-layout) .month-footers {
  flex-direction: column;
}
:host(.mobile-layout) .month-footers .month {
  flex: 0 0 auto;
  width: 100%;
}
.calendar-header .title-button.active-view {
  background-color: var(--aur-calendar-range-background, #eef3fa);
  color: var(--aur-calendar-focus, #235081);
}
.period-grid {
  color: var(--aur-calendar-text, #1d222c);
  font-family: var(--aur-calendar-font-family, "Inter Tight", "Helvetica Neue", Helvetica, system-ui, sans-serif);
  font-size: 14px;
  line-height: 1.5;
}
:host(.mobile-layout) .calendar-body.stable-size {
  height: 298px;
}
:host(.mobile-layout).compact-on-small-screens .calendar-body.stable-size {
  height: auto;
}
.calendar-header button:hover:not(:disabled),
.calendar-header button:active:not(:disabled) {
  background-image: none;
  background-color: var(--aur-calendar-header-hover, #f6f7f9);
}
.calendar-title {
  color: var(--aur-calendar-heading-text, #12151c);
}
.navigation-slot button.unavailable {
  visibility: hidden;
}
/*# sourceMappingURL=aur-datepicker.component.css.map */
